import { useAuth } from '../contexts/AuthContext'
import UsernameModal from './UsernameModal'
import PageLoader from './ui/PageLoader'

/**
 * Guardrail component that ensures the user has a valid username/handle
 * before they can access the authenticated parts of the app.
 */
function UsernameCheck({ children }) {
  const { currentUser, loading, isAuthenticated } = useAuth()

  // If still loading auth state, show loader
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-darkest text-text-light">
        <PageLoader />
      </div>
    )
  }

  // If not authenticated, we don't handle it here (RequireAuth does)
  if (!isAuthenticated) {
    return children
  }

  // FORCE username selection if missing from Auth or Player services.
  // This acts as a hard guardrail - they cannot see the Sidebar or Shelter
  // until these values are populated.
  const hasUsername = currentUser?.username
  const hasHandle = currentUser?.handle

  if (!hasUsername || !hasHandle) {
    return <UsernameModal />
  }

  return children
}

export default UsernameCheck
